// extracted by mini-css-extract-plugin
export default {"toggle":"toggle___2X0AH","open":"open___3yBGR","defaultTooltipIcon":"defaultTooltipIcon___1Jlmq"};